const Colors = {
  blue: "#004b92",
  yellow: "#e3c500",
  white: "#ffffff",
}

export default Colors
